// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"eb0065ec","100":"844e10db","484":"dddaf5d7","551":"d885a1da","851":"df532489"}[chunkId] + ".chunk.js";
};